import { useState } from 'react';
import CreateDiscountServices from 'features/DigitalAccount/DiscountCode/CreateDiscount/services/CreateDiscountServices';

function useGuildsList() {
  const [guildsList, setGuildsList] = useState([]);
  const [businessGuildsList, setBusinessGuildsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(true);

  const getGuildsList = async (val = '') => {
    setGuildListLoading(true);

    try {
      const q = { query: encodeURI(val) };
      const res = await CreateDiscountServices.getGuildsList(q);
      const guildsData = res?.result?.guilds;
      const businessGuildsDate = res?.result?.businessGuilds;

      if (guildsData.length > 0) {
        let list = [];
        list = guildsData.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val?.name} - ${val?.code}`,
          value: val.id,
          code: val?.code,
        }));
        setGuildsList(list);
      }

      if (businessGuildsDate.length > 0) {
        let list = [];
        list = businessGuildsDate.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val?.name} - ${val?.code}`,
          value: val.id,
          code: val?.code,
        }));
        setBusinessGuildsList(list);
      }
    } catch (e) {}

    setGuildListLoading(false);
  };
  return { guildsList, guildListLoading, getGuildsList, businessGuildsList };
}

export { useGuildsList };
